export const environment = {
  version: require('../../package.json').version,
  production: true,
  EXIBIR_SIMULADOR_INATIVO: false,
  DESABILITAR_CCI_PRO_COTISTA: false,
  INTERNET_BANKING_URL: 'https://digital.poupex.com.br/',
  HOMEBANKING_API: 'https://homebankingapi.poupex.com.br/',
  FINANCIAMENTO_API: 'https://financiamentoapi.poupex.com.br/',
  SIMULADOR_API: 'https://simuladorimobiliarioapi.poupex.com.br/',
  CAPTCHA_SITE_KEY: '6Lc0cnQUAAAAAMhhQAeRHPmsj0CKC3J9OPpHhzP9',
  LEAD_URL: 'https://www.poupex.com.br/produtos/credito-imobiliario/cadastre-se/',
  TRACKING_ID: 'UA-18439031-11',
  APP_POUPEX_APPLE_STORE: 'https://apps.apple.com/br/app/poupex/id1505649884',
  APP_POUPEX_GOOGLE_PLAY: 'https://play.google.com/store/apps/details?id=br.com.poupex.m',
  INTERNET_BANKING_CID: 'https://digital.poupex.com.br/credito-imobiliario/',
  FORMULARIO_SIMULADOR_GEOPI: 'https://digital.poupex.com.br/proposta-compra-imoveis?idSimulacao=',
  IFRAME_ALLOWED_URLS: [
    'https://privacidadedadoslogin.poupex.com.br',
    'https://poupexdigital.poupex.com.br',
    'https://digital.poupex.com.br',
    'https://centraldenegociacoes.poupex.com.br',
    'https://plane.poupex.com.br'
  ],
  URL_PDF_BENEFICIOS_POUPEX: 'https://www.poupex.com.br/wp-content/themes/POUPEX/assets/pdf/Regulamento_Pacote_Beneficios_Credito_Imobiliario_FHE.pdf',
  URL_CONHECA_SEU_PERFIL: 'https://www.poupex.com.br/conheca-o-seu-perfil/simulador/',
  URL_MATERIAL_CONSTRUCAO: 'https://www.poupex.com.br/credito-imobiliario/aquisicao-de-material-de-construcao/#simulador-credito-material-construcao',
  FORM_CONTA_DIGITAL: 'https://poupexdigital.poupex.com.br/'
};
